import React from "react";
import ErrorImage from "../assets/ErrorImage.svg";

const PageNotFound = () => {
  return (
    <div className="flex items-center w-full h-screen">
      <div className="w-full max-w-md mx-auto text-center">
        <h1 className="text-3xl font-medium">Something went wrong</h1>
        <img src={ErrorImage} alt="errorImg" className="mx-auto my-10" />
        <p>The requested page wasn't found.</p>
      </div>
    </div>
  );
};

export default PageNotFound;
